(() => {
  const money = (cents) => `EGP ${(Number(cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const roots = document.querySelectorAll('[data-hanso-conversion]');
  roots.forEach((root) => {
    const ar = root.dataset.ar === 'true';

    const share = document.querySelector('[data-hanso-share]');
    if (share && !share.dataset.hansoShareBound) share.addEventListener('click', async () => {
      const original = ar ? 'مشاركة' : 'Share';
      try {
        if (navigator.share) await navigator.share({ title: share.dataset.title, url: share.dataset.url });
        else {
          await navigator.clipboard.writeText(share.dataset.url);
          share.querySelector('[data-label]').textContent = ar ? 'تم نسخ الرابط' : 'Link copied';
          setTimeout(() => { share.querySelector('[data-label]').textContent = original; }, 1800);
        }
      } catch (error) {
        if (error?.name !== 'AbortError') window.prompt(ar ? 'انسخ رابط المنتج' : 'Copy product link', share.dataset.url);
      }
    });

    const story = root.querySelector('[data-hanso-story-grid]');
    if (story) {
      const storyBlock = story.closest('.hanso-brand-story');
      const storyImages = [...story.querySelectorAll('[data-hanso-story-image]')];
      const variantMarkers = [...story.querySelectorAll('[data-hanso-story-variant]')];
      const captions = [story.dataset.captionOne, story.dataset.captionTwo, story.dataset.captionThree];
      const readVariantId = () => {
        const checked = document.querySelector('variant-picker input[data-variant-id]:checked');
        const fromUrl = new URLSearchParams(window.location.search).get('variant');
        return String(checked?.dataset.variantId || fromUrl || story.dataset.initialVariantId || '');
      };
      const renderStory = (requestedVariantId) => {
        const variantId = String(requestedVariantId || readVariantId());
        const marker = variantMarkers.find((item) => item.dataset.hansoStoryVariant === variantId)
          || variantMarkers.find((item) => item.dataset.hansoStoryVariant === story.dataset.initialVariantId)
          || variantMarkers[0];
        let matches = [];
        if (story.dataset.singleton === 'true') {
          matches = storyImages.length > 1 ? storyImages.slice(1, 4) : storyImages.slice(0, 1);
        } else if (marker?.dataset.storyGroup) {
          matches = storyImages
            .filter((item) => item.dataset.storyGroup === marker.dataset.storyGroup)
            .sort((a, b) => Number(a.dataset.storyImageIndex || 0) - Number(b.dataset.storyImageIndex || 0));
          if (matches.length > 1 && Number(matches[0].dataset.storyImageIndex) === 1) matches = matches.slice(1, 4);
          else matches = matches.slice(0, 3);
        } else if (marker?.dataset.storyMediaId) {
          matches = storyImages.filter((item) => item.dataset.storyMediaId === marker.dataset.storyMediaId).slice(0, 1);
        }
        storyImages.forEach((item) => { item.hidden = true; });
        matches.forEach((item, index) => {
          item.hidden = false;
          const caption = item.querySelector('[data-hanso-story-caption]');
          if (caption) caption.textContent = captions[Math.min(index, 2)] || '';
        });
        if (storyBlock) storyBlock.hidden = matches.length === 0;
      };
      renderStory();
      document.addEventListener('change', (event) => {
        const input = event.target.closest?.('variant-picker input[data-variant-id]');
        if (!input) return;
        renderStory(input.dataset.variantId);
        setTimeout(() => renderStory(), 250);
      });
      window.addEventListener('popstate', () => renderStory());
    }

    root.addEventListener('click', async (event) => {
      const quickAdd = event.target.closest?.('[data-hanso-compare-quick-add]');
      if (!quickAdd || quickAdd.disabled) return;
      event.preventDefault();
      event.stopPropagation();
      const variantId = Number(quickAdd.dataset.variantId || 0);
      if (!variantId) return;
      const symbol = quickAdd.querySelector('span');
      quickAdd.disabled = true;
      quickAdd.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!response.ok) throw new Error(`Cart ${response.status}`);
        quickAdd.classList.add('is-added');
        if (symbol) symbol.textContent = '✓';
        quickAdd.setAttribute('aria-label', ar ? 'تمت الإضافة إلى السلة' : 'Added to cart');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(() => {
          quickAdd.classList.remove('is-added');
          quickAdd.disabled = false;
          quickAdd.removeAttribute('aria-busy');
          if (symbol) symbol.textContent = '+';
        }, 1400);
      } catch {
        quickAdd.disabled = false;
        quickAdd.removeAttribute('aria-busy');
        quickAdd.setAttribute('aria-label', ar ? 'تعذرت الإضافة، حاول مرة أخرى' : 'Could not add, try again');
      }
    });

    if (share) share.dataset.hansoShareBound = 'true';
    const bundle = root.querySelector('[data-hanso-bundle]');
    if (!bundle) return;
    const total = bundle.querySelector('[data-bundle-total]');
    const status = bundle.querySelector('[data-bundle-status]');
    const button = bundle.querySelector('[data-bundle-add]');
    const selectedVariantId = () => document.querySelector('form[action*="/cart/add"] input[name="id"]:checked, form[action*="/cart/add"] input[name="id"]')?.value;
    const checkboxes = [...bundle.querySelectorAll('input[type="checkbox"]')];
    const update = () => {
      const cents = checkboxes.filter((box) => box.checked).reduce((sum, box) => sum + Number(box.dataset.price || 0), 0);
      total.textContent = money(cents);
      button.disabled = !checkboxes.some((box) => box.checked && !box.disabled) && !checkboxes.some((box) => box.checked && box.hasAttribute('data-bundle-current'));
    };
    checkboxes.forEach((box) => box.addEventListener('change', update));
    update();

    button.addEventListener('click', async () => {
      const items = [];
      const current = bundle.querySelector('[data-bundle-current]');
      if (current?.checked) {
        const id = selectedVariantId();
        if (id) items.push({ id: Number(id), quantity: 1 });
      }
      bundle.querySelectorAll('[data-bundle-item]:checked').forEach((box) => items.push({ id: Number(box.dataset.variantId), quantity: 1 }));
      if (!items.length) return;
      button.disabled = true;
      status.textContent = ar ? 'جارٍ إضافة المنتجات…' : 'Adding items…';
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        if (!response.ok) throw new Error(`Cart ${response.status}`);
        status.textContent = ar ? 'تمت الإضافة إلى السلة' : 'Added to cart';
        window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
      } catch {
        status.textContent = ar ? 'تعذر إضافة كل المنتجات. جرّب مرة أخرى.' : 'Could not add all items. Please try again.';
        button.disabled = false;
      }
    });
  });
})();

(() => {
  if (window.hansoUnifiedRailVariants) return;
  window.hansoUnifiedRailVariants = true;
  document.addEventListener('click', event => {
    const swatch = event.target.closest?.('[data-rail-variant]');
    if (!swatch) return;
    event.preventDefault(); event.stopPropagation();
    const card = swatch.closest('[data-hanso-unified-card]');
    if (!card) return;
    card.querySelectorAll('[data-rail-variant]').forEach(b=>b.setAttribute('aria-pressed', String(b===swatch)));
    const img=card.querySelector('[data-rail-image]'); img.src=swatch.dataset.image;
    card.querySelectorAll('[data-rail-link]').forEach(a=>a.href=swatch.dataset.url);
    const add=card.querySelector('[data-hanso-compare-quick-add]'); if(add)add.dataset.variantId=swatch.dataset.id;
    const price=Number(swatch.dataset.price), compare=Number(swatch.dataset.compare);
    const money=(node,n)=>{
      const parts=(n/100).toFixed(2).split('.');
      const wrapper=document.createElement('span');wrapper.className='hanso-amazon-money';wrapper.dir='ltr';wrapper.setAttribute('aria-label','EGP '+parts.join('.'));
      for(const [tag,cls,value] of [['span','currency','EGP'],['span','whole',Number(parts[0]).toLocaleString('en-US')],['sup','fraction',parts[1]]]){const el=document.createElement(tag);el.className='hanso-amazon-money__'+cls;el.textContent=value;wrapper.append(el);}
      node.replaceChildren(wrapper);
    };
    money(card.querySelector('[data-rail-price]'),price);
    const old=card.querySelector('[data-rail-original]');old.hidden=!(compare>price);if(compare>price)money(old,compare);else old.replaceChildren();
  }, true);
})();
